<template>
    <div></div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
    name: 'writeLetterTheme',
    props: {
        items: {
            type: Object,
            default: () => ([]),
        },
    },
    data: () => ({
        themes: {},
        regions: {},
        cityes: {},
        selectRegion: null,
        selectCity: null,
        regionFocus: false,
        cityFocus: false,
        ajaxProcessed: false,
        showForm: false,
        textRegion: "",
        textCity: "",
        sendFormCheck: false,
        confirmConsent: false,
        selectIdTheme: null
    }),
    created() {
        this.themes = this.items.themes;
        this.regions = this.items.regions;
        this.cityes = this.items.city;
    },
    mounted() {
		if (this.items.themes) {
			if (Object.keys(this.items.themes).find(key => this.items.themes[key].selected)) {
				this.showForm = true;
				this.$nextTick(() => {
					setTimeout(() => window.propMultipleAddButton(), 1000);
				})
			}
		}
    },
    computed: {
        getRegions() {

            let regions = [];
            for (let key in this.regions) {
                if (this.textRegion != "") {
                    if (this.regions[key].NAME.toLowerCase().indexOf(this.textRegion.toLowerCase()) > -1) {
                        regions.push(this.regions[key]);
                    }
                } else {
                    regions.push(this.regions[key]);
                }
            }
            return regions;
        },
        getCities() {
            if (!this.selectRegion) {
                return [];
            }

            let citys = [];
            for (let key in this.cityes) {
                if (this.cityes[key].IBLOCK_SECTION_ID == this.selectRegion) {
                    if (this.textCity != "") {

                        if (this.cityes[key].NAME.toLowerCase().indexOf(this.textCity.toLowerCase()) > -1) {
                            citys.push(this.cityes[key]);
                        }
                    } else {
                        citys.push(this.cityes[key]);
                    }
                }
            }
            return citys;
        },
        ...mapGetters({
            getYandexSiteKey: 'getYandexSiteKey',
        })
    },
    watch: {},

    methods: {
        getTheme(event) {
			const select = event.target;
			if (!select) return
			if (parseInt(select.value) > 0) {
                this.selectIdTheme = parseInt(select.value);
				this.showForm = true;
			} else {
				this.showForm = false;
			}
			setTimeout(() => {
				setPhoneMask($('.mask-phone'));
				window.propMultipleAddButton();
			}, 1000)
        },
        sendForm() {
            const container = document.getElementById("contacts_feedback_form_form_container");
            container.classList.add("ajax_processed");
            this.setYandexCaptchaCallback(this.sendRequest);
            this.sendFormCheck = true;

            let form = event.target.closest("form");
            let valid = true;

            if (this.getCities.length === 0) {
                showHeaderMessage('Выберете город из списка', 'error');
                valid = false;
            } else {
                if (!this.selectCity) {
                    let selectCity = this.selectCity;
                    for (let ind in this.getCities) {
                        if (this.getCities[ind].NAME == this.textCity) {
                            this.selectCity = this.getCities[ind].ID;
                        }
                    }
                }
                if (!this.selectCity) {
                    showHeaderMessage('Выберете город из списка', 'error');
                    valid = false;
                }
            }


            form.querySelectorAll("input").forEach((input) => {
                if (input.closest(".form_row")) {
                    if (input.checkValidity()) {
                        input.closest(".form_row").classList.remove("error");
                        if (input.classList.contains("mask-phone") === true) {

                            let phone = input.value.match(/\d+/ig).join("");
                            if (phone.length < 11) {
                                input.closest(".form_row").classList.add("error");
                                valid = false;
                            }
                        }

                        if (input.classList.contains("change-city") === true && !this.selectCity) {
                            input.closest(".form_row").classList.add("error");
                            valid = false;
                        }

                    } else {
                        input.closest(".form_row").classList.add("error");
                        valid = false;
                    }
                }
            });


            if (this.getCities.length === 0) {
                showHeaderMessage('Выберете город из списка', 'error');
                valid = false;
            } else {
                if (!this.selectCity) {
                    let selectCity = this.selectCity;
                    for (let ind in this.getCities) {
                        if (this.getCities[ind].NAME == this.textCity) {
                            this.selectCity = this.getCities[ind].ID;
                        }
                    }
                }
                if (!this.selectCity) {
                    showHeaderMessage('Выберете город из списка', 'error');
                    valid = false;
                }
                if (this.selectCity) {
                    this.correctCity()
                }
            }

            event.preventDefault();
            let el = this;
            if (valid === true) {
                if (!window.smartCaptcha) return;
                window.smartCaptcha.reset();
                window.smartCaptcha.execute();
                return;
            }
            return false;
        },
        sendRequest() {
            const container = document.getElementById("contacts_feedback_form_form_container");
            const form = document.getElementById("contacts_feedback_form");
            if (!container || !form) return
            let formData = new FormData(form)
            formData.append("ajax_command", "addForm");
            formData.append("z", true);
            formData.append("yatoken", window.smartCaptcha.getResponse());

            fetch("/local/php_interface/ajax/", {
                method: 'POST',
                body: formData
            }).then(
                response => {
                    response.json().then(answer => {
                        if (answer.success == true) {
                            window.$.fancybox.close();
                            container.classList.remove("ajax_processed");
                            showHeaderMessage(this.items.messageAdd, 'success');
                            form.querySelectorAll("input,textarea").forEach((input) => {
                                if (
                                    input.getAttribute('type') == "text"
                                    || input.getAttribute("type") == "tel"
                                    || input.getAttribute("type") == "email"
                                    || input.getAttribute("type") == "file"
                                    || input.getAttribute("type") == null
                                ) {
                                    input.value = "";
                                }
                            });
                        } else {
                            if (answer.error) {
                                container.classList.remove("ajax_processed");
                                showHeaderMessage(answer.error, 'error');
                            }
                        }
                    });
                },
            );
        },
        setParam(par) {
            this[par] = true;
        },
        deleteParam(par) {
            let el = this;
            setTimeout(() => {
                el[par] = false;
            }, 300)
        },
        setRegion(region) {
            this.selectRegion = region.ID;
            this.textRegion = region.NAME;
        },
        correctCity() {
            if (this.selectCity) {
                const city = this.getCities.find(i => i.ID === this.selectCity)
                this.textCity = city ? city.NAME : '';
            } else {
                this.textCity = ''
            }
        },
        setCity(city) {
            this.selectCity = city.ID;
            this.textCity = city.NAME;
        },
        listChangeKeyUp(param) {
            if (param == 'region') {
                if (this.selectRegion) this.selectRegion = false;
            } else if (param == 'city') {
                if (this.selectCity) this.selectCity = false;
            }
        },
        ...mapMutations({
            'setYandexCaptchaCallback': 'setYandexCaptchaCallback',
        }),
        ...mapActions({
            'initYandexCaptcha': 'initYandexCaptcha',
        })
    },
}
</script>
